import URLConfig from "@Config/urls/url.config";
import { LinkItemProps } from "@Layouts/sidebar/AppSidebar";

const URL = URLConfig.ADMIN.ARCHIVING.BATCHES_MENU;

const BatchesMenuLink: Array<LinkItemProps> = [
  {
    name: "Supervision des batches",
    link: URL.SUPERVISION_OF_BATCHES,
    level: 3,
  },
  {
    name: "Paramètres de purge",
    link: URL.PURGE_SETTINGS,
    level: 3,
  },
];

export default BatchesMenuLink;
